exports.SETTINGS = {

    _SERVER : '',   // TODO

    MAXSLIDES: 699,

    USE_LOADIMAGES: true,

    USE_LOADMASK: false,

    BREAKPOINTS: {
        small: 426,
        tablet: 769
    }
};
